import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import Charts from '../../common/Charts/Charts';
import * as insight360Actions from '../../../actions/insight360Actions';
import {
  processData,
  checkReportDataAvailable,
  desOrderSortedArr,
} from '../../../util/Insight360Utils';
import Insight360ReportSearchComponent from '../../common/Insight360ReportSearchComponent';
import infoIconWhite from '../../../images/insight360/info-icon_white.png';
import {
  WEIGHTED_LABEL,
  REACH_LABEL,
  INSIGHT_360_DICTIONARY_NODE_ID,
  INGSIGHT_360_REPORTVIEW_REPORT_NAME,
  REPORTS_PERSONA_REQUIRED,
  REPORTS_DATA_POINT_REQUIRED,
  SAMPLE_LABEL,
  REPORT_GRAPH_ITEM_LIMIT,
  REPORTS_GRAPH_LIMIT_NOTE,
  SELECT_QUESTION_FOR_REPORT,
  CHANGE_SORT_OPTION_REPORTER,
  SELECT_INDEX_FILETR_REPORTER,
  SELECT_PERCENT_FILTER_REPORTER,
  REPORT_COLORS,
} from '../../../constants';
import { numberWithCommas, exportFileTitle } from '../../../util/CommonUtils';
import {
  WEIGHTED_INFO_MSG,
  REACH_INFO_MSG,
  SAMPLE_INFO_MSG,
  INSIGHTS_REPORTS_QUESTION_REFRESH_WARNING,
  INSIGHTS_REPORT_NO_DATA_MSG,
} from '../../../messages/messages';
import clearFilterIcon from '../../../images/insight360/clear-field-icon_white.png';
import clearBaseIcon from '../../../images/insight360/clear-field-icon_190-190-190.png';
import indexIcon from '../../../images/index-icon_white.png';
import percentageIcon from '../../../images/percent-icon_white.png';

import * as messages from '../../../messages/ReportsMessages';
import Modal from '../../common/Modal/Modal';
import GenericButton from '../../common/GenericButton';

const seriesSelectionModalStyle = {
  width: '40%',
  height: '40px',
  left: '30%',
  top: '10%',
};

const modalWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

class Reports360 extends Component {
  constructor(props) {
    super(props);
    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.state = {
      treedata:
        this.props.dictionaryTree !== undefined
          ? this.props.dictionaryTree
          : [],
      categoryExpanded: {},
      selectedRadioButton:
        this.props.insights360ReportSortInfo !== undefined &&
          this.props.insights360ReportSortInfo.sortBy !== undefined
          ? this.props.insights360ReportSortInfo.sortBy
          : 'Index',
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
      selectedCategory:
        this.props.selectedCategory !== undefined
          ? this.props.selectedCategory
          : '',
      personaExpression:
        this.props.insight360PersonaExpression !== undefined
          ? this.props.insight360PersonaExpression
          : [],
      personaLabel:
        this.props.insight360PersonaLabel !== undefined
          ? this.props.insight360PersonaLabel
          : [],
      insights360Reports:
        this.props.insights360Reports !== undefined
          ? this.props.insights360Reports
          : [],
      personaPct:
        this.props.insight360PersonaPct !== undefined
          ? this.props.insight360PersonaPct
          : [],
      personaWeighted:
        this.props.insight360PersonaWeighted !== undefined
          ? this.props.insight360PersonaWeighted
          : [],
      personaSample:
        this.props.insight360PersonaSample !== undefined
          ? this.props.insight360PersonaSample
          : [],
      isLoading: true,
      detailsNotLoaded: false,
      personaFilter:
        this.props.insight360PersonaFilter !== undefined
          ? this.props.insight360PersonaFilter
          : [],
      personaActiveSortIndex: undefined,
      checkBoxNode:
        this.props.insight360VariableSelection !== undefined
          ? this.props.insight360VariableSelection
          : [],
      checkboxSelectionNode:
        this.props.insight360VariableSelection !== undefined
          ? this.props.insight360VariableSelection
          : [],
      tempInsight360Reports:
        this.props.insights360Reports !== undefined
          ? this.props.insights360Reports
          : [],
      activateApplyBtn: false,
      selectAllBtn: true,
      toggleReportBlocksWidth: false,
      removeReportIndex: '',
      bcStudy:
        this.props.smartSearchStudy !== undefined
          ? this.props.smartSearchStudy
          : '',
      rerenderGraphBasedOnSelectedCat: false,
    };
    if (
      this.props.loginResponse &&
      this.props.activeAccountId
    ) {
      this.props.insight360Actions.getDictionaryTreeLoad(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.state.bcStudy.pn,
        INSIGHT_360_DICTIONARY_NODE_ID,
      );
    }

    this.resetDictionaryTreeData = this._resetDictionaryTreeData.bind(this);
    this.searcDictionaryTreeData = this._searcDictionaryTreeData.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (
      this.props.insight360PersonaExpression &&
      this.props.insight360PersonaExpression.length > 0 &&
      this.props.selectedCategory !== undefined &&
      !_.isEmpty(this.props.selectedCategory)
    ) {
      this.onCategoryChange(this.props.selectedCategory);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
    if (
      this.props.dictionaryTree !== nextProps.dictionaryTree &&
      nextProps.dictionaryTree &&
      nextProps.dictionaryTree.status === 200
    ) {
      this.setState({
        treedata: [
          {
            keyword: 'SIMMONSTYPE',
            midpoint: null,
            node: 0,
            rectype: 'C',
            uniqueId: '-1',
            children: [...nextProps.dictionaryTree.data],
          },
        ],
      });
    }

    if (
      this.props.insight360PersonaExpression !==
      nextProps.insight360PersonaExpression
    ) {
      this.setState({
        personaExpression: nextProps.insight360PersonaExpression,
      });
    }

    if (
      this.props.insight360PersonaLabel !== nextProps.insight360PersonaLabel
    ) {
      this.setState({ personaLabel: nextProps.insight360PersonaLabel });
    }

    if (this.props.insight360PersonaPct !== nextProps.insight360PersonaPct) {
      this.setState({ personaPct: nextProps.insight360PersonaPct });
    }

    if (
      this.props.insight360PersonaWeighted !==
      nextProps.insight360PersonaWeighted
    ) {
      this.setState({ personaWeighted: nextProps.insight360PersonaWeighted });
    }

    if (
      this.props.insight360PersonaSample !== nextProps.insight360PersonaSample
    ) {
      this.setState({ personaSample: nextProps.insight360PersonaSample });
    }

    if (this.props.insights360Reports !== nextProps.insights360Reports) {
      const insightReports = _.cloneDeep(nextProps.insights360Reports);
      if (insightReports && insightReports.length > 0) {
        if (nextProps.insights360Reports[0].detailGroups &&
          nextProps.insights360Reports[0].detailGroups.length <= REPORT_GRAPH_ITEM_LIMIT) {
            this.checkBoxNode = [];
            const allCategoriesList = insightReports[0].detailGroups;
           if (!this.state.rerenderGraphBasedOnSelectedCat) {
             allCategoriesList.forEach((item, index) => {
                 this.checkBoxNode.push({
                   value: item.label,
                   label: item.label,
                   expression: item.expression,
                   isChecked: true,
                 });
           })
         }
          this.setState({
            insights360Reports: nextProps.insights360Reports,
            isLoading: false,
            tempInsight360Reports: nextProps.insights360Reports,
            selectAllBtn: true,
            detailsNotLoaded: false,
            checkBoxNode: this.checkBoxNode,
          }, () => {
            this.props.reportAvailable(checkReportDataAvailable(nextProps.insights360Reports));
          });
        } else if (insightReports[0].detailGroups &&
          insightReports[0].detailGroups.length > REPORT_GRAPH_ITEM_LIMIT) {
          const allCategoriesList = insightReports[0].detailGroups;
          const sortKey = this.state.selectedRadioButton === 'Index' ? 'index' : 'pct';
          const sortedCategoriesList = desOrderSortedArr(allCategoriesList, sortKey);
          this.checkBoxNode = [];
          const checked = [];
          if (!this.state.rerenderGraphBasedOnSelectedCat) {
            allCategoriesList.forEach((item, index) => {
                const indexVal = _.findIndex(sortedCategoriesList, item);
                if (item && indexVal > -1 && indexVal < 50) {
                this.checkBoxNode.push({
                  value: item.label,
                  label: item.label,
                  expression: item.expression,
                  isChecked: true,
                });
              } else {
                this.checkBoxNode.push({
                  value: item.label,
                  label: item.label,
                  expression: item.expression,
                  isChecked: false,
                });
              }
              checked.push(item.label);
            });
          } else {
            this.checkBoxNode = _.cloneDeep(this.state.checkBoxNode);
          }
          let detailgroups = insightReports[0].detailGroups;
          detailgroups = detailgroups.filter((item, index) => {
            return (index < REPORT_GRAPH_ITEM_LIMIT);
          });
          insightReports[0].detailGroups = detailgroups;
          this.setState({
            insights360Reports: nextProps.insights360Reports,
            isLoading: false,
            tempInsight360Reports: nextProps.insights360Reports,
            selectAllBtn: false,
            checkBoxNode: this.checkBoxNode,
            checkboxSelectionNode: this.checkBoxNode,
            detailsNotLoaded: false,
          }, () => {
            this.props.reportAvailable(checkReportDataAvailable(nextProps.insights360Reports));
          });
        } else {
          this.setState({ detailsNotLoaded: true }, () => {
            this.props.reportAvailable(false);
          });
          this.props.insight360Actions.set360ReportsSelectionVariables([]);
        }
      } else {
        this.setState({
          insights360Reports: nextProps.insights360Reports,
          isLoading: false,
          tempInsight360Reports: nextProps.insights360Reports,
          selectAllBtn: false,
        });
      }
    }

    if (
      this.props.insight360PersonaFilter !== nextProps.insight360PersonaFilter
    ) {
      this.setState({
        personaFilter: nextProps.insight360PersonaFilter,
        isLoading: false,
      });
    }

    if (
      this.props.insight360PersonaExpression !==
      nextProps.insight360PersonaExpression &&
      this.props.insight360PersonaLabel !== nextProps.insight360PersonaLabel &&
      this.state.selectedCategory !== undefined &&
      !_.isEmpty(this.state.selectedCategory)
    ) {
      this.setState(
        {
          personaLabel: nextProps.insight360PersonaLabel,
          personaExpression: nextProps.insight360PersonaExpression,
        },
        () => {
          this.onCategoryChange(this.state.selectedCategory);
        },
      );
    }

    if (
      this.props.insight360VariableSelection !==
      nextProps.insight360VariableSelection
    ) {
      this.setState({ checkBoxNode: nextProps.insight360VariableSelection });
    }

    if (this.props.selectedCategory !== nextProps.selectedCategory) {
      this.setState({ selectedCategory: nextProps.selectedCategory });
    }

    if (this.state.bcStudy !== nextProps.smartSearchStudy) {
      this.setState({ bcStudy: nextProps.smartSearchStudy }, () => {
        this.resetDictionaryTreeData();
      });
      this.onCategoryChange(this.state.selectedCategory);
    }

    if (
      this.props.insight360Base !== nextProps.insight360Base &&
      nextProps.insight360Base !== undefined &&
      this.state.selectedCategory !== undefined &&
      !_.isEmpty(this.state.selectedCategory)
    ) {
      this.onCategoryChange(this.state.selectedCategory);
    }

    if (!this.props.bcReportExport && nextProps.bcReportExport) {
      this.bcReportExportAction();
    }
  }

  onCategoryChange = ({ category, keyword, rectype, uniqueId, node }, e) => {
    this.setState({ rerenderGraphBasedOnSelectedCat : false });
    if (
      this.state.personaExpression !== undefined &&
      (this.state.personaExpression.length > 0) && (rectype === 'Q')
    ) {
      if (e) {
        const selectedElement = e.target;
        if ($(selectedElement).hasClass('category-question')) {
          const breadCrumbList = [];
          const parentsList = $($(e.target).closest('li')).parents('.dynamic-brand-tree-node');
          $(parentsList).each((index, item) => {
            breadCrumbList.push($(item).attr('data-path'));
          });
          window.localStorage.setItem('brandCatalystBreadCrumb', JSON.stringify(breadCrumbList));
        }
      }

      this.props.trackerFn({
        action: SELECT_QUESTION_FOR_REPORT,
        attributes: { question: category },
      });
      const filters = this.state.personaFilter;
      const expressions = this.state.personaExpression;
      const modifiedExpression = [];
      if (category !== this.state.selectedCategory.category) {
        this.props.insight360Actions.set360ReportsSelectionVariables([]);
      }
      _.forEach(expressions, (expression, index) => {
        let newExpression = `(${expression})`;
        if (filters[index] !== '') {
          newExpression = `${newExpression} AND (${filters[index]})`;
        }
        modifiedExpression.push(newExpression);
      });
      this.setState({ isLoading: true });
      const insightSearchPersonasParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        personaLabels: this.state.personaLabel,
        personaExpressions: modifiedExpression,
      };
      const questions = [];
      this.setState({
        selectedCategory: { category, keyword, rectype, uniqueId, node },
      });
      if (node !== undefined) {
        if (_.isNumber(node)) {
          questions.push(node.toString());
        } else {
          node.split(',').forEach(nodeval => questions.push(nodeval));
        }
      }
      this.props.insight360Actions.getInsight360Personas(
        insightSearchPersonasParams,
        INGSIGHT_360_REPORTVIEW_REPORT_NAME,
        null,
        questions,
      );
      this.props.insight360Actions.set360DictionarySelectedCategory({
        category,
        keyword,
        rectype,
        uniqueId,
        node,
      });
    } else {
      // this.setState({ selectedCategory: { category, keyword, rectype, uniqueId, node } });
      /* this.props.insight360Actions.set360DictionarySelectedCategory({
        category, keyword, rectype, uniqueId, node }); */
    }
  };

  getCategoryClasses = category =>
    `category ${
    category.rectype === 'Q' ? 'category-question' : 'category-folder'
    } ${
    this.state.selectedCategory.category === category.shortText
      ? '--category-selected'
      : ''
    }`;

  getChildren = category => {
    // if (category.children && category.children.length && (category.rectype === 'C')) {
    if (category.children && category.children.length) {
      return this.renderCategories(category.children);
    }
    return false;
  };

  _resetDictionaryTreeData() {
    this.setState({ treedata: [] });
    this.collapseAll();
    this.props.insight360Actions.getDictionaryTreeLoad(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      this.state.bcStudy.pn,
      INSIGHT_360_DICTIONARY_NODE_ID,
    );
  }

  _searcDictionaryTreeData(searchType, searchText) {
    this.setState({ treedata: [] });
    this.collapseAll();
    this.props.insight360Actions.searchDictionaryReportTree(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      this.state.bcStudy.pn,
      searchType,
      searchText,
    );
  }

  collapseAll = () => {
    this.setState({ categoryExpanded: [] });
  };

  calculateAsterisk = sample => {
    if (this.state.showSingleAsterisk || this.state.showSingleAsterisk) {
      if (sample < 31) {
        return '**';
      }
      if (sample < 61) {
        return '*';
      }
    }

    return '';
  };

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  handleNodeClick = category => {
    const node =
      typeof category.node !== 'undefined' ? category.node : category.recno;
    this.setState({
      categoryExpanded: {
        ...this.state.categoryExpanded,
        ...{ [node]: !this.state.categoryExpanded[node] },
      },
    });

    if (typeof category.children === 'undefined') {
      this.props.insight360Actions.getDictionaryTreeLoad(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.state.bcStudy.pn,
        node,
      );
    }
  };

  handleRadioButtonChange = e => {
    if (!this.state.rerenderGraphBasedOnSelectedCat) {
      const ResetNodeTree = [];
      const sortByKey = e.currentTarget.value === 'Index' ? 'index' : 'pct';
      const  allCategoriesList = _.cloneDeep(this.state.insights360Reports[0].detailGroups);
      const sortedCategoriesList = desOrderSortedArr(allCategoriesList, sortByKey);
      allCategoriesList.forEach((item, i) => {
       const index = _.findIndex(sortedCategoriesList, item);
       if(item && index > -1 && index < 50) {
        ResetNodeTree.push({
          value: item.label,
          label: item.label,
          expression: item.expression,
          isChecked: true,
        });
       } else {
        ResetNodeTree.push({
          value: item.label,
          label: item.label,
          expression: item.expression,
          isChecked: false,
        });
       }
     })
     this.setState({ checkBoxNode : ResetNodeTree })
      }  
    if (e.currentTarget.value === 'Index') {
      this.props.trackerFn({ action: SELECT_INDEX_FILETR_REPORTER });
    } else {
      this.props.trackerFn({ action: SELECT_PERCENT_FILTER_REPORTER });
    }
    this.setState({ selectedRadioButton: e.currentTarget.value });
  };

  /* backToExplorer = e => {
    this.props.onselectedtab('EXPLORE')
  } */

  sortReportChart = sortVal => {
    if (sortVal !== undefined) {
      this.props.trackerFn({
        action: CHANGE_SORT_OPTION_REPORTER,
        attributes: { option: `${sortVal.sortBy} ${sortVal.type}` },
      });
      this.props.insight360Actions.set360ReporterSortInfo({
        index: sortVal.index,
        type: sortVal.type,
        sortBy: sortVal.sortBy,
      });
      this.setState({
        selectedRadioButton: sortVal.sortBy,
        personaActiveSortIndex: undefined,
      });
    } else {
      this.setState({
        personaActiveSortIndex: undefined,
      });
    }
  };

  showReportSortDropdown = val => {
    this.setState({
      personaActiveSortIndex: val,
    });
  };

  toggleReportBlocksWidth = () => {
    this.setState({
      toggleReportBlocksWidth: !this.state.toggleReportBlocksWidth,
    });
  };

  handleSelectVariableBtnClick = () => {
    if (this.state.checkBoxNode.length === 0) {
      const availableDataIdx = checkReportDataAvailable(this.state.insights360Reports, true);
      const checkBoxTreeData = this.state.insights360Reports[availableDataIdx].detailGroups;
      this.checkBoxNode = [];
      const checked = [];
      checkBoxTreeData.forEach(item => {
        this.checkBoxNode.push({
          value: item.label,
          label: item.label,
          expression: item.expression,
          isChecked: true,
        });
        checked.push(item.label);
      });
      this.setState({
        checkBoxNode: this.checkBoxNode,
        checkboxSelectionNode: this.checkBoxNode,
      });
    } else if (this.state.checkBoxNode.every(item => item.isChecked === true)) {
      if ((this.state.checkBoxNode.filter(item => item.isChecked === true).length) >
        REPORT_GRAPH_ITEM_LIMIT) {
        this.setState({
          activateApplyBtn: true,
          selectAllBtn: true,
          checkBoxNode: this.state.checkBoxNode,
          checkboxSelectionNode: this.state.checkBoxNode,
        });
      } else {
        this.setState({
          activateApplyBtn: false,
          selectAllBtn: true,
          checkBoxNode: this.state.checkBoxNode,
          checkboxSelectionNode: this.state.checkBoxNode,
        });
      }
    } else if ((this.state.checkBoxNode.filter(item => item.isChecked === true).length) >
        REPORT_GRAPH_ITEM_LIMIT) {
        this.setState({
          activateApplyBtn: true,
          selectAllBtn: false,
          checkBoxNode: this.state.checkBoxNode,
          checkboxSelectionNode: this.state.checkBoxNode,
        });
      } else {
        this.setState({
          activateApplyBtn: false,
          selectAllBtn: false,
          checkBoxNode: this.state.checkBoxNode,
          checkboxSelectionNode: this.state.checkBoxNode,
        });
      }
    this.seriesSelectionModal.show();
  };

  handleVariableCheckboxClick = (e, value) => {
    const tempChecboxNode = _.cloneDeep(this.state.checkboxSelectionNode);
    tempChecboxNode.forEach((item, index) => {
      if (value === item.label) {
        tempChecboxNode[index].isChecked = !item.isChecked;
      }
    });
    this.setState({ checkboxSelectionNode: tempChecboxNode });
    const applyBtnSelected = tempChecboxNode.every(
      item => item.isChecked !== true,
    );
    this.setState({ activateApplyBtn: applyBtnSelected });
    if ((tempChecboxNode.filter(item => item.isChecked === true).length) >
      REPORT_GRAPH_ITEM_LIMIT) {
      this.setState({ activateApplyBtn: true });
    }
    if (tempChecboxNode.every(item => item.isChecked === true)) {
      this.setState({ selectAllBtn: true });
    }
    if (tempChecboxNode.every(item => item.isChecked === false)) {
      this.setState({ selectAllBtn: false });
    }
  };

  handleRedrawGraph = () => {
    this.setState({ rerenderGraphBasedOnSelectedCat : true });
    this.setState({ checkBoxNode: this.state.checkboxSelectionNode });
    this.seriesSelectionModal.hide();
    this.props.insight360Actions.set360ReportsSelectionVariables(
      this.state.checkboxSelectionNode,
    );
  };

  handleSelectAllClick = e => {
    const tempChecboxNode = _.cloneDeep(this.state.checkboxSelectionNode);
    const len = tempChecboxNode.length;
    if (e.target.checked) {
      this.setState({ selectAllBtn: true });
      tempChecboxNode.forEach((item, index) => {
        tempChecboxNode[index].isChecked = true;
      });
      this.setState({
        checkboxSelectionNode: tempChecboxNode,
        activateApplyBtn: false,
      });
      if (len > REPORT_GRAPH_ITEM_LIMIT) {
        this.setState({ activateApplyBtn: true });
      }
    } else {
      this.setState({ selectAllBtn: false });
      tempChecboxNode.forEach((item, index) => {
        tempChecboxNode[index].isChecked = false;
      });
      this.setState({
        checkboxSelectionNode: tempChecboxNode,
        activateApplyBtn: true,
      });
    }
  };

  handleRemoveReportClick = index => {
    this.state.removeReportIndex = index;
    this.modalWarining.show();
    // this.props.removeDemographic(this.props.index);
  };

  removeModalOk = () => {
    this.props.removeReportPersona(this.state.removeReportIndex);
    this.modalWarining.hide();
  };
  // findFilterLabel = (filter) =>{
  //   if (this.props.filterOptions !== undefined ) {
  //     let y = this.props.filterOptions.data;
  //     let z = _.flatMap(y);
  //     return _.find(z, {keyword: filter});
  //   }
  // }

  handleClearBaseClick = () => {
    this.props.insight360Actions.set360Base(undefined);
    this.onCategoryChange(this.props.selectedCategory);
    this.props.baseExpressionChanged();
  };

  bcReportExportAction = () => {
    const { insight360Base, activeAccountId, loginResponse } = this.props;
    const sortInfo = this.getReportSortInfo();
    sortInfo.sortBy = this.state.selectedRadioButton;
    const filters = this.state.personaFilter;
    const expressions = this.state.personaExpression;
    const modifiedExpression = [];
    _.forEach(expressions, (expression, index) => {
      let newExpression = `(${expression})`;
      if (filters[index] !== '') {
        newExpression = `${newExpression} AND ${filters[index]}`;
      }
      modifiedExpression.push(newExpression);
    });
    const selReportRows = _.filter(this.state.checkBoxNode, 'isChecked');
    const questions = [];
    const node = this.state.selectedCategory.node;
    if (node !== undefined) {
      if (_.isNumber(node)) {
        questions.push(node.toString());
      } else {
        node.split(',').forEach(nodeval => questions.push(nodeval));
      }
    }
    let fileName = exportFileTitle('BrandCatalyst');
    if(this.props.selectedTab === 'REPORTS') {
      fileName = exportFileTitle('BrandCatalyst_Reporter');
    } else if(this.props.selectedTab === 'EXPLORE') {
      fileName = exportFileTitle('BrandCatalyst_Persona');
    } else if(this.props.selectedTab === 'CREATOR') {
      fileName = exportFileTitle('BrandCatalyst_Creator');
    }
    const data = {
      uid: loginResponse.data.uid,
      accountId: activeAccountId,
      personaLabels: this.state.personaLabel,
      personaExpressions: modifiedExpression,
      reportName: INGSIGHT_360_REPORTVIEW_REPORT_NAME,
      productNo: this.state.bcStudy.pn,
      warningType: this.state.bcStudy.wnt,
      base: insight360Base,
      questions,
      sortOrder: _.isEmpty(sortInfo.type) ? 'asc' : sortInfo.type,
      sortBy: sortInfo.sortBy === 'Percent' ? 'pct' : _.toLower(sortInfo.sortBy),
      sortIdx: sortInfo.index,
      colorPrefs: _.map(REPORT_COLORS, o => _.toUpper(o)),
      questionLabel: this.state.selectedCategory.category,
      reportRows: !_.isEqual(selReportRows, this.state.checkBoxNode) ?
      _.map(selReportRows, o => ({ label: o.label, expression: o.expression })) : [],
      fileName,
    };
    this.props.insight360Actions.exportBrandCatalystReport(data).then(response => {
      if (!_.isEmpty(response)) {
        window.open(response.url, '_self');
      }
    });
  }

  getReportSortInfo = () => {
    const { insights360ReportSortInfo } = this.props;
    const { tempInsight360Reports } = this.state;
    const sortInfo = !_.isEmpty(insights360ReportSortInfo) ? 
    {
      index: 0,
      type: 'desc',
      sortBy: 'Index',
    }: {
      index: 0,
      type: 'desc',
      sortBy: '',
    };

    if (tempInsight360Reports[sortInfo.index].detailGroups.length === 0) {
      const findIndex = _.findIndex(tempInsight360Reports, o => o.detailGroups.length > 0);
      sortInfo.index = findIndex;
    }
    return sortInfo;
  }

  isReportDataAvailable = index => {
    const { tempInsight360Reports } = this.state;
    if (index !== undefined && tempInsight360Reports[index]) {
      return tempInsight360Reports[index].detailGroups.length > 0;
    }
    return checkReportDataAvailable(tempInsight360Reports);
  }

  renderCategories = data =>
    data.map(category => {
      const node =
        typeof category.node !== 'undefined' ? category.node : category.recno;
      return (
        <li
          key={node}
          data-path={category.shortText}
          className="dynamic-brand-tree-node"
        >
          <div className="category-name">
            {category.rectype !== 'Q' ? (
              <button
                className={
                  this.props.selectedCategoryID === category.keyword
                    ? 'caret-icon caret-white'
                    : 'caret-icon caret-blue'
                }
                onClick={() => this.handleNodeClick(category)}
              >
                {this.state.categoryExpanded[node]
                  ? String.fromCharCode(9660)
                  : String.fromCharCode(9654)}
              </button>
            ) : (
                false
              )}
            <button
              className={this.getCategoryClasses(category)}
              onClick={e =>
                this.onCategoryChange({
                  category: category.shortText,
                  keyword: category.keyword,
                  rectype: category.rectype,
                  uniqueId: category.uniqueId,
                  node,
                }, e)
              }
              title={`${category.rectype === 'Q' ? 'Q. ' : 'F. '} ${
                category.shortText
                }`}
            >
              <div className="full-selected" />
              {category.rectype === 'Q' ? 'Q. ' : ''}
              {category.shortText}
            </button>
          </div>
          <ul>
            {this.state.categoryExpanded[node]
              ? this.getChildren(category)
              : false}
          </ul>
        </li>
      );
    });

  renderHeaders() {
    const checkBoxSelectionNode = _.cloneDeep(this.state.checkboxSelectionNode);
    const selectedCheckBoxItems = checkBoxSelectionNode &&
      checkBoxSelectionNode.length > 0 ?
      checkBoxSelectionNode.filter(item => item.isChecked === true) : [];
    const isReportChartVisible =
      this.state.insights360Reports !== undefined &&
      this.state.insights360Reports.length > 0 && !this.state.detailsNotLoaded;

    return (
      <div>
        <Modal
          title=""
          ref={node => (this.modalWarining = node)}
          dialogStyles={modalWariningStyle}
        >
          <div className="text-center">
            <p>This is going to delete this Selection</p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => {
                this.removeModalOk();
              }}
            />
          </div>
        </Modal>
        <Modal
          title="Select variables"
          ref={node => (this.seriesSelectionModal = node)}
          dialogStyles={seriesSelectionModalStyle}
        >
          <div className="text-center">
            <div>
              <div className="report-checkbox-tree">
                <div className="checkbox-container">
                  <div className="checkbox-select-all">
                    <input
                      type="checkbox"
                      checked={this.state.selectAllBtn}
                      onChange={e => this.handleSelectAllClick(e)}
                      name="select-all"
                      id="select-all-360"
                    />
                    <label htmlFor="select-all-360" className="checkbox-label">
                      Select All/UnSelect All
                    </label>
                    {this.state.activateApplyBtn &&
                      this.state.checkboxSelectionNode &&
                      selectedCheckBoxItems.length > 50 &&
                      <span className="report-limit-note"><b>Note:</b> {REPORTS_GRAPH_LIMIT_NOTE} {REPORT_GRAPH_ITEM_LIMIT}</span>}
                  </div>
                  <div className="all-checkbox">
                    {this.state.checkboxSelectionNode.map((item, index) => (
                      <div key={`checkbox${index}`}>
                        <input
                          type="checkbox"
                          onChange={e =>
                            this.handleVariableCheckboxClick(e, item.value)
                          }
                          id={item.value}
                          name={item.value}
                          checked={item.isChecked}
                        />
                        <label htmlFor={item.value} className="checkbox-label">{item.label}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <GenericButton
              name="Apply"
              btnStyle="button btn-cncl button-125px"
              btnDisabled={this.state.activateApplyBtn}
              onBtnClick={() => this.handleRedrawGraph()}
            />
          </div>
        </Modal>

        {/* <div className="row expanded">
          <div className="large-1 medium-1 small-1 columns"> &nbsp; </div>
          <div className="large-7 medium-7 small-7 columns">
            {this.props.insight360Base !== undefined &&
              this.props.insight360Base.baseLabel !== undefined &&
              <span className="base">BASE: {this.props.insight360Base.baseLabel}</span>
            }
          </div>
          <div className="large-3 medium-3 small-3 columns">
            <button
              onClick={this.backToExplorer}
              className="back-to-boards float-right"
              title="Back to explorer">
              Back to explorer
                  </button>
          </div>
        </div> */}

        <div className="row expanded">
          <div
            className="large-12 medium-12 small-12 columns"
            id="reportHeader"
          >
            {this.state.personaLabel.length === 1 &&
              this.state.personaWeighted.length === 1 &&
              this.state.personaPct.length === 1 &&
              this.state.personaSample.length === 1 && (<div className="row expanded">
                <div
                  className="large-12 medium-12 small-12 columns"
                  id="reportPersonaHeader"
                >
                  <div className="div-overflow">
                    <span
                      className="persona-reporter-info single-info label-ellipsis float-left"
                      title={this.state.personaLabel[0]}
                    >
                      {this.state.personaLabel[0]}
                    </span>
                    <span className="float-right">
                      <button
                        type="button"
                        className="i360_header_icons_img reportPdfflag"
                        onClick={() => this.handleRemoveReportClick(0)}
                      >
                        <img src={clearFilterIcon} alt="Remove" />
                      </button>
                    </span>
                  </div>
                  <div className="clearfix margin-bottom-5">
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data">
                        {numberWithCommas(
                          Math.round(this.state.personaSample[0]),
                        )}
                      </div>
                      <div className="demographic-float weight-reach-comparision-info">
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data">
                        {numberWithCommas(
                          Math.round(this.state.personaWeighted[0]),
                        )}
                      </div>
                      <div className="demographic-float weight-reach-comparision-info">
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data">
                        {Math.round(this.state.personaPct[0] * 10) / 10}%
                      </div>
                      <div className="demographic-float weight-reach-comparision-info">
                        {REACH_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float-right margin-top-10">
                     &nbsp;
                    </div>
                  </div>
                </div>
              </div>
              )}

            {this.state.personaLabel.length === 2 &&
              this.state.personaWeighted.length === 2 &&
              this.state.personaPct.length === 2 &&
              this.state.personaSample.length === 2 && (<div className="row expanded">
                <div
                  className="large-6 medium-6 small-6 columns reporter-pesona-divider"
                  id="reportPersonaHeader"
                >
                  <div className="div-overflow">
                    <span
                      className="persona-reporter-info label-ellipsis float-left"
                      title={this.state.personaLabel[0]}
                    >
                      {this.state.personaLabel[0]}
                    </span>
                    <span className="float-right">
                      <button
                        type="button"
                        className="i360_header_icons_img reportPdfflag"
                        onClick={() => this.handleRemoveReportClick(0)}
                      >
                        <img src={clearFilterIcon} alt="Remove" />
                      </button>
                    </span>
                  </div>
                  <div className="clearfix margin-bottom-5">
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data report-double">
                        {numberWithCommas(
                          Math.round(this.state.personaSample[0]),
                        )}
                      </div>
                      <div className="demographic-float weight-reach-comparision-info report-double">
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data report-double">
                        {numberWithCommas(
                          Math.round(this.state.personaWeighted[0]),
                        )}
                      </div>
                      <div className="demographic-float weight-reach-comparision-info report-double">
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data report-double">
                        {Math.round(this.state.personaPct[0] * 10) / 10}%
                      </div>
                      <div className="demographic-float weight-reach-comparision-info report-double">
                        {REACH_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float-right">
                     &nbsp;
                    </div>
                  </div>
                </div>
                <div
                  className="large-6 medium-6 small-6 columns"
                  id="reportDoublePersonaHeader"
                >
                  <div className="div-overflow">
                    <span
                      className="persona-reporter-info label-ellipsis float-left"
                      title={this.state.personaLabel[1]}
                    >
                      {this.state.personaLabel[1]}
                    </span>
                    <span className="float-right">
                      <button
                        type="button"
                        className="i360_header_icons_img reportPdfflag"
                        onClick={() => this.handleRemoveReportClick(1)}
                      >
                        <img src={clearFilterIcon} alt="Remove" />
                      </button>
                    </span>
                  </div>
                  <div className="clearfix margin-bottom-5">
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data report-double">
                        {numberWithCommas(
                          Math.round(this.state.personaSample[1]),
                        )}
                      </div>
                      <div className="demographic-float weight-reach-comparision-info report-double">
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data report-double">
                        {numberWithCommas(
                          Math.round(this.state.personaWeighted[1]),
                        )}
                      </div>
                      <div className="demographic-float weight-reach-comparision-info report-double">
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float margin-left-10">
                      <div className="demographic-float weight-reach-comparision-data report-double">
                        {Math.round(this.state.personaPct[1] * 10) / 10}%
                      </div>
                      <div className="demographic-float weight-reach-comparision-info report-double">
                        {REACH_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                    </div>
                    <div className="demographic-float-right">
                     &nbsp;
                    </div>
                  </div>
                </div>
              </div>
              )}

            {this.state.personaLabel.length === 3 &&
              this.state.personaWeighted.length === 3 &&
              this.state.personaPct.length === 3 &&
              this.state.personaSample.length === 3 && (<div className="row expanded">
                <div
                  className="large-4 medium-4 small-4 columns demographic-detail-columns reporter-pesona-divider"
                  id="reportPersonaHeader"
                >
                  <div className="div-overflow">
                    <span
                      className="persona-reporter-info triple-info label-ellipsis float-left"
                      title={this.state.personaLabel[0]}
                    >
                      {this.state.personaLabel[0]}
                    </span>
                    <span className="float-right">
                      <button
                        type="button"
                        className="i360_header_icons_img reportPdfflag"
                        onClick={() => this.handleRemoveReportClick(0)}
                      >
                        <img src={clearFilterIcon} alt="Remove" />
                      </button>
                    </span>
                  </div>
                  <div className="row margin-bottom-10 padding-left-10">
                    <div className="columns small-3 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                      <div>
                        {numberWithCommas(
                          Math.round(this.state.personaSample[0]),
                        )}
                      </div>
                    </div>
                    <div className="columns small-5 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                      <div>
                        {numberWithCommas(
                          Math.round(this.state.personaWeighted[0]),
                        )}
                      </div>
                    </div>
                    <div className="columns small-3 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {REACH_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                      <div>
                        {Math.round(this.state.personaPct[0] * 10) / 10}%
                      </div>
                    </div>
                    <div className="columns small-1">
                      <div className="demographic-float-right margin-top-15">
                       &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="large-4 medium-4 small-4 columns demographic-detail-columns reporter-pesona-divider"
                  id="reportDoublePersonaHeader"
                >
                  <div className="div-overflow">
                    <span
                      className="persona-reporter-info triple-info label-ellipsis float-left"
                      title={this.state.personaLabel[1]}
                    >
                      {this.state.personaLabel[1]}
                    </span>
                    <span className="float-right">
                      <button
                        type="button"
                        className="i360_header_icons_img reportPdfflag"
                        onClick={() => this.handleRemoveReportClick(1)}
                      >
                        <img src={clearFilterIcon} alt="Remove" />
                      </button>
                    </span>
                  </div>
                  <div className="row margin-bottom-10 padding-left-10">
                    <div className="columns small-3 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag reportPdfflag"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                      <div>
                        {numberWithCommas(
                          Math.round(this.state.personaSample[1]),
                        )}
                      </div>
                    </div>
                    <div className="columns small-5 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                      <div>
                        {numberWithCommas(
                          Math.round(this.state.personaWeighted[1]),
                        )}
                      </div>
                    </div>
                    <div className="columns small-3 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {REACH_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                      <div>
                        {Math.round(this.state.personaPct[1] * 10) / 10}%
                      </div>
                    </div>
                    <div className="columns small-1">
                      <div className="demographic-float-right margin-top-15">
                       &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="large-4 medium-4 small-4 columns demographic-detail-columns"
                  id="reportTriplePersonaHeader"
                >
                  <div className="div-overflow">
                    <span
                      className="persona-reporter-info triple-info label-ellipsis float-left"
                      title={this.state.personaLabel[2]}
                    >
                      {this.state.personaLabel[2]}
                    </span>
                    <span className="float-right">
                      <button
                        type="button"
                        className="i360_header_icons_img reportPdfflag"
                        onClick={() => this.handleRemoveReportClick(2)}
                      >
                        <img src={clearFilterIcon} alt="Remove" />
                      </button>
                    </span>
                  </div>
                  <div className="row margin-bottom-10 padding-left-10">
                    <div className="columns small-3 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                      <div>
                        {numberWithCommas(
                          Math.round(this.state.personaSample[2]),
                        )}
                      </div>
                    </div>
                    <div className="columns small-5 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                      <div>
                        {numberWithCommas(
                          Math.round(this.state.personaWeighted[2]),
                        )}
                      </div>
                    </div>
                    <div className="columns small-3 data-comparision-tb-section report-view">
                      <div className="comparision-info-label">
                        {REACH_LABEL}
                        <img
                          className="i360_header_icons_img size-sm reportPdfflag"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                      <div>
                        {Math.round(this.state.personaPct[2] * 10) / 10}%
                      </div>
                    </div>
                    <div className="columns small-1">
                      <div className="demographic-float-right margin-top-15">
                       &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { smartSearchStudy } = this.props;
    const isMRISpecificStudy = smartSearchStudy.ss.includes('MRI');
    const warningType = smartSearchStudy.wnt;
    const breadcrumbList = !_.isEmpty(window.localStorage.getItem('brandCatalystBreadCrumb')) ? JSON.parse(window.localStorage.getItem('brandCatalystBreadCrumb')) : undefined;
    const breadCrumbValue = breadcrumbList ? breadcrumbList.reverse().join(' > ') : this.state.selectedCategory.category;
    return (
      <div>
        <div className="row expanded">
          <div
            className={`insight360-report-leftside-block ${
              this.state.toggleReportBlocksWidth ? 'w-collapsed' : ''
              }`}
          >
            <div className="insigt360-report-search-section">
              <div>
                <Insight360ReportSearchComponent
                  moduleStudy={smartSearchStudy}
                  searchDictionaryTree={this.searcDictionaryTreeData}
                  resetDictionaryTree={this.resetDictionaryTreeData}
                />
              </div>
            </div>
            <div className="insight360-report-dictionary">
              {this.state.treedata.length > 0 &&
                this.renderCategories(this.state.treedata[0].children)}
              {this.state.treedata.length > 0 &&
                this.state.treedata[0].children.length === 0 &&
                (<span>{INSIGHTS_REPORT_NO_DATA_MSG}</span>)}
              {this.state.treedata.length === 0 && <span>Loading...</span>}
            </div>
          </div>
          <div
            className={`insight360-report-rightside-block ${
              this.state.toggleReportBlocksWidth ? 'w-expanded' : ''
              }`}
            id="report-grid"
          >
            <div className="insight360-report-toggle-icon">
              <button
                type="button"
                className={`i360-toggle-sidebar ${
                  this.state.toggleReportBlocksWidth ? 'active' : ''
                  }`}
                onClick={this.toggleReportBlocksWidth}
              >
                &nbsp;
              </button>
            </div>
            <div
              className={`i360-report-header ${
                this.state.insights360Reports !== undefined &&
                  this.state.insights360Reports.length > 0
                  ? 'active'
                  : ''
                } `}
            >
              <div className="row expanded">
                <div className="large-12 medium-12 small-12 columns base-report-div">
                  {this.props.insight360Base !== undefined &&
                    this.props.insight360Base.baseLabel !== undefined && (<span
                      className="base base-report"
                      id="report-label-ellipsis"
                      title={this.props.insight360Base.baseLabel}
                    >
                      {' '}
                      BASE: {this.props.insight360Base.baseLabel}
                    </span>
                    )}
                  {this.props.insight360Base !== undefined &&
                    this.props.insight360Base.baseLabel !== undefined && (<button
                      type="button"
                      className="i360_header_icons_img"
                      id="baseReportRemoveIcon"
                      onClick={() => this.handleClearBaseClick()}
                    >
                      <img src={clearBaseIcon} alt="Remove" />
                    </button>
                    )}
                </div>
              </div>
              {this.state.personaLabel.length > 0 && this.renderHeaders()
                /* <PersonaHeader
                filterExpressionChanged={this.props.filterExpressionChanged}
                removeDemographic={this.props.removeDemographic}
                personaFilter={this.props.insight360PersonaFilter} isReports = {true}/> */
              }
              {this.state.personaLabel.length === 0 && (
                <div className="insight360-reports-info">
                  Note: {REPORTS_PERSONA_REQUIRED}
                </div>
              )}
              {this.state.personaLabel.length > 0 &&
                _.isEmpty(this.state.selectedCategory) && (<div className="insight360-reports-info">
                  Note: {REPORTS_DATA_POINT_REQUIRED}
                </div>
                )}
              {this.state.insights360Reports !== undefined &&
               this.state.personaLabel.length > 0 &&
                this.state.insights360Reports.length > 0 && (<div className="row expanded" id="reportGraphHeading">
                  <div className="large-12 medium-12 small-12 columns text-center margin-top-10 margin-bottom-5">
                    <div className="row expanded">
                      <div className="large-8 medium-8 small-8 text-left columns">
                        <span
                          className="insight360-report-category-label pdfSelectedCategory"
                          title={this.state.selectedCategory.category}
                        >
                          {this.state.selectedCategory.category}
                        </span>
                        <br />
                        <span
                          className="insight360-report-category-folder-label label-ellipsis pdfSelectedCategory"
                          title={breadCrumbValue}
                        >
                          {breadCrumbValue}
                        </span>
                      </div>
                      {!this.state.isLoading && !this.state.detailsNotLoaded &&
                        this.isReportDataAvailable() && (<div className="large-4 medium-4 small-4 right columns reportPdfflag">
                          <div className="insight360-stv-radio-buttons-wrapper">
                            <button
                              className="i360-reporter-select-series-icon-img"
                              onClick={this.handleSelectVariableBtnClick}
                              title="Select Variables"
                            />
                            <input
                              type="radio"
                              id="indexType"
                              name="ChartType"
                              className="insight360-stv-radio-button"
                              checked={
                                this.state.selectedRadioButton === 'Index'
                              }
                              onChange={this.handleRadioButtonChange}
                              value="Index"
                            />
                            <label htmlFor="indexType">
                              <img
                                className="i360_reporter_icons_img "
                                src={indexIcon}
                                alt="Index"
                                title="Index"
                              />
                            </label>
                            <input
                              type="radio"
                              className="insight360-stv-radio-button"
                              id="percentType"
                              name="ChartType"
                              checked={
                                this.state.selectedRadioButton === 'Percent'
                              }
                              onChange={this.handleRadioButtonChange}
                              value="Percent"
                            />
                            <label htmlFor="percentType">
                              <img
                                className="i360_reporter_icons_img "
                                src={percentageIcon}
                                alt="Percent"
                                title="Percent"
                              />
                            </label>
                          </div>
                        </div>
                        )}
                    </div>
                  </div>
                </div>
                )}
            </div>
            <div className="insight360-report-chart-div">
              <div className="row expanded">
                <div
                  className="large-12 medium-12 small-12 columns"
                  id="pdfReportChart"
                >
                  {this.state.insights360Reports !== undefined &&
                   this.state.personaLabel.length > 0 &&
                    this.state.insights360Reports.length > 0 && (<div className="insight360-quick-report-graph-wrapperr">
                      <div className="large-12 medium-12 small-12 columns">
                        <div className="row expanded">
                          <div className="large-1 medium-1 small-1 columns">
                            {' '}
                            &nbsp;{' '}
                          </div>
                          <div className="large-10 medium-10 small-10 columns">
                            {this.state.isLoading && !this.state.detailsNotLoaded &&
                              <span>Loading...</span>}
                            {this.state.isLoading && this.state.detailsNotLoaded &&
                              <span className="no-data-report">{INSIGHTS_REPORTS_QUESTION_REFRESH_WARNING}</span>}
                            {this.state.isLoading === false &&
                              this.isReportDataAvailable() &&
                              (<Charts
                                config={processData(
                                  {
                                    rawData: this.state
                                      .tempInsight360Reports,
                                    selectedIndex: this.state
                                      .selectedRadioButton,
                                    selectedSeries: this.state.checkBoxNode,
                                  },
                                  this.updateAsteriskStatus,
                                  this.getReportSortInfo(), // this.props.insights360ReportSortInfo
                                  this.props.smartSearchStudy,
                                )}
                              />
                              )}
                            {!this.state.isLoading &&
                              !this.isReportDataAvailable() && (<p className="margin-top-10">
                                Data is not available for the selected persona(s).
                              </p>
                              )}
                          </div>
                          <div className="large-1 medium-1 small-1 columns">
                            {/* <img
                            onClick ={() => {
                              this.props.download("Reports", "report","report-grid","Reports")
                            }} className="export-icon-class" src={downloadIconDefault} /> */}
                          </div>
                        </div>
                      </div>
                      {!this.state.isLoading && !isMRISpecificStudy && this.isReportDataAvailable() && (
                        <div className="large-12 medium-12 small-12 columns">
                          <div className="row expanded position-relative font-11">
                            <div className="small-9 columns">
                              <div>
                                <div className="padding-astrick">
                                  {messages.CELL_COUNT_31_60}
                                </div>
                                <div className="padding-astrick">
                                  {messages.CELL_COUNT_BELOW_31}
                                </div>
                              </div>
                            </div>
                            {
                              this.props.sourceDataInfo('small-5 columns i360-report-src-data-info text-align-right pdfReportSourceInfo')
                            }
                          </div>
                        </div>
                      )}
                      {!this.state.isLoading && isMRISpecificStudy && this.isReportDataAvailable() && (
                        <div className="large-12 medium-12 small-12 columns">
                          <div className="row expanded position-relative font-11">
                            <div className="small-9 columns">
                              {warningType === 6 && (
                                <div>
                                  <div className="padding-astrick">
                                    {messages.MRI_CELL_COUNT_BELOW_50}
                                  </div>
                                </div>
                              )}
                              {warningType === 7 && (
                                <div>
                                  <div className="padding-astrick">
                                    {messages.MRI_CELL_COUNT_25_49}
                                  </div>
                                  <div className="padding-astrick">
                                    {messages.MRI_CELL_COUNT_BELOW_25}
                                  </div>
                                </div>
                              )}
                              {warningType === 8 && (
                                <div>
                                  <div className="padding-astrick">
                                    {messages.MRI_CELL_COUNT_31_59}
                                  </div>
                                  <div className="padding-astrick">
                                    {messages.MRI_CELL_COUNT_BELOW_31}
                                  </div>
                                </div>
                              )}
                            </div>
                            {this.props.sourceDataInfo('small-5 columns i360-report-src-data-info text-align-right pdfReportSourceInfo')}
                          </div>
                        </div>
                      )}
                    </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Reports360.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  definitionList: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  /* download: PropTypes.func, */
  insight360Base: PropTypes.shape({}),
  /* onselectedtab: PropTypes.func, */
  sourceDataInfo: PropTypes.func,
  smartSearchStudy: PropTypes.shape({}),
  removeReportPersona: PropTypes.func,
  insights360ReportSortInfo: PropTypes.shape({}),
  trackerFn: PropTypes.func,
  insight360Actions: PropTypes.shape({
    searchDictionaryReportTree: PropTypes.func,
    getDictionaryTreeLoad: PropTypes.func,
    set360ReporterSortInfo: PropTypes.func,
    set360Base: PropTypes.func,
    set360ReportsSelectionVariables: PropTypes.func,
    set360DictionarySelectedCategory: PropTypes.func,
    getInsight360Personas: PropTypes.func,
  }),
  baseExpressionChanged: PropTypes.func,
  reportAvailable: PropTypes.func,
  activeAccountId: PropTypes.number,
  bcReportExport: PropTypes.bool,
  selectedTab: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    insight360PersonaExpression: state.insight360.insight360PersonaExpression,
    insight360PersonaLabel: state.insight360.insight360PersonaLabel,
    dictionaryTree: state.insight360.insight360ReportsDictionaryTree,
    activeAccountId: state.account.activeAccountId,
    insights360Reports: state.insight360.insights360Reports,
    tempInsight360Reports: state.insight360.insights360Reports,
    insight360VariableSelection: state.insight360.insight360VariableSelection,
    insight360PersonaPct: state.insight360.insight360PersonaPct,
    insight360PersonaWeighted: state.insight360.insight360PersonaWeighted,
    insight360PersonaSample: state.insight360.insight360PersonaSample,
    selectedCategory: state.insight360.selectedCategory,
    insight360PersonaFilter: state.insight360.insight360PersonaFilter,
    filterOptions: state.insight360.insight360DemographicsFilterOptions,
    insight360Base: state.insight360.insight360Base,
    smartSearchStudy: state.study.insight360study,
    insights360ReportSortInfo: state.insight360.insights360ReportSortInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(Reports360);
